<template>
  <div class="inventory-types-wrapper">
    <inventory-types-index></inventory-types-index>
  </div>
</template>

<script>
import InventoryTypesIndex from '../InventoryTypes/Index.vue';

export default {
  name: "InventorySectionsIndex", // Keeping legacy name to avoid route breaks if lazy
  components: {
    InventoryTypesIndex
  }
};
</script>


